/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Versions } from '../../models/versions';

export interface GetVersion$Params {
  service?: string;
}

export function getVersion(http: HttpClient, rootUrl: string, params?: GetVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<Versions>> {
  const rb = new RequestBuilder(rootUrl, getVersion.PATH, 'get');
  if (params) {
    rb.query('service', params.service, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Versions>;
    })
  );
}

getVersion.PATH = '/api/version';
